import { InlineSvg } from 'components/svg';
import { FallbackProps } from 'react-error-boundary';

interface Props {
  message?: string | undefined;
}

const ErrorFallback = ({ error }: FallbackProps) => {
  const message = `Error : ${error.message || '-'} Stack : ${error.stack}`;
  return <ErrorAlert message={message} />;
};

const ErrorAlert = ({ message }: Props) => {
  return (
    <div className="alert bg-light-danger  border-danger border-dashed d-flex flex-center flex-column py-10 px-10 px-lg-20 m-20">
      <button
        type="button"
        className="position-absolute top-0 end-0 m-2 btn btn-icon btn-icon-danger"
        data-bs-dismiss="alert"
      >
        <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1" />
      </button>

      <InlineSvg
        path="/media/icons/duotune/general/gen044.svg"
        className="svg-icon svg-icon-5tx svg-icon-danger mb-5"
      ></InlineSvg>

      <div className="text-center">
        <h5 className="fw-bolder fs-1 mb-5">Something went wrong</h5>

        <div className="mb-9">{message}</div>
      </div>
    </div>
  );
};

export { ErrorFallback, ErrorAlert };
